import QdContainer from 'components/Common/QdContainer'
import React, { useState } from 'react'
import Header from './Header'
import ApptSysForm from './ApptSysForm'
import { Provider } from './ApptSysContext'
import ApptSysList from './ApptSysList'

function ApptSys() {
    const [showForm, setShowForm] = useState(false)
    const [editSystem, setEditSystem] = useState(null)

    const handleAdd = () => {
        setEditSystem(null);
        setShowForm(true);
    };

    const handleEdit = (system) => {
        setEditSystem(system);
        setShowForm(true);
    };

    const hideForm = () => {
        setShowForm(false);
        setEditSystem(null);
    };

    return (
        <Provider>
            <QdContainer>
                <Header onAdd={handleAdd} />
                {showForm && <ApptSysForm hideForm={hideForm} editSystem={editSystem} />}
                {!showForm && <ApptSysList onAdd={handleAdd} onEdit={handleEdit} />}
            </QdContainer>
        </Provider>
    )
}

export default ApptSys